import React from 'react';
import { Button } from 'reactstrap';
import { Form } from '../types';
import { ValueValidation } from '@g17eco/types/universalTracker';
import { TableTypeConfiguration } from './TableTypeConfiguration';
import { ColumnSummaryTable } from './ColumnSummaryTable';

interface Props {
  formData: Form;
  setValueValidation: (value: ValueValidation) => void;
  isAnswered: boolean;
  onAddColumn?: () => void;
  onEditColumn?: (code: string) => void;
}

export const TableConfiguration = ({ formData, setValueValidation, isAnswered, onAddColumn, onEditColumn }: Props) => {
  const columns = formData.valueValidation?.table?.columns ?? [];

  const handleDeleteColumn = (code: string) => {
    if (window.confirm('Are you sure you want to delete this column?')) {
      const newColumns = columns.filter((col) => col.code !== code);

      const maxRows = formData.valueValidation?.table?.validation?.maxRows;

      setValueValidation({
        ...formData.valueValidation,
        table: {
          ...formData.valueValidation.table,
          columns: newColumns,
          validation: maxRows ? { maxRows } : undefined,
        },
      });
    }
  };

  return (
    <div>
      <TableTypeConfiguration formData={formData} setValueValidation={setValueValidation} isAnswered={isAnswered} />

      <ColumnSummaryTable
        columns={columns}
        onEdit={(code) => onEditColumn?.(code)}
        onDelete={handleDeleteColumn}
        isAnswered={isAnswered}
      />

      <div className='mt-3 mb-2'>
        {!isAnswered && (
          <Button color='primary' onClick={onAddColumn} disabled={isAnswered}>
            <i className='fa fa-plus mr-2' />
            Add table column
          </Button>
        )}
      </div>
    </div>
  );
};
